import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enCommon from "./locales/en/Common.json";
import frCommon from "./locales/fr/Common.json";
import enHome from "./locales/en/HomePage.json";
import frHome from "./locales/fr/HomePage.json";
import enProjects from "./locales/en/ProjectsDetails.json";
import frProjects from "./locales/fr/ProjectsDetails.json";
import enWork from "./locales/en/OurWorkPage.json";
import frWork from "./locales/fr/OurWorkPage.json";
import enAboutUs from "./locales/en/AboutUsPage.json";
import frAboutUs from "./locales/fr/AboutUsPage.json";
import enServices from "./locales/en/ServicesPage.json";
import frServices from "./locales/fr/ServicesPage.json";
import enContact from "./locales/en/ContactPage.json";
import frContact from "./locales/fr/ContactPage.json";

export const LANGUAGE_KEY = "oxide.lang";

// A language picked on the site wins over the browser's language.
function initialLanguage() {
    try {
        const saved = window.localStorage.getItem(LANGUAGE_KEY);
        if (saved === "en" || saved === "fr") return saved;
    } catch (e) {
        // Storage blocked: fall back to the browser language.
    }
    const browserLang = navigator.language || navigator.userLanguage || "en";
    return browserLang.split('-')[0] === "fr" ? "fr" : "en";
}

i18n
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                Common: enCommon,
                HomePage: enHome,
                ProjectsDetails: enProjects,
                OurWorkPage: enWork,
                AboutUsPage: enAboutUs,
                ServicesPage: enServices,
                ContactPage: enContact
            },
            fr: {
                Common: frCommon,
                HomePage: frHome,
                ProjectsDetails: frProjects,
                OurWorkPage: frWork,
                AboutUsPage: frAboutUs,
                ServicesPage: frServices,
                ContactPage: frContact
            }
        },
        lng: initialLanguage(),
        fallbackLng: "en",
        ns: ['Common', 'HomePage', 'ProjectsDetails', 'OurWorkPage', 'AboutUsPage', 'ServicesPage', 'ContactPage'],
        defaultNS: 'Common',
        interpolation: {
            escapeValue: false
        }
    });

i18n.on("languageChanged", (lng) => {
    document.documentElement.lang = lng;
});
document.documentElement.lang = i18n.language;

export default i18n;
